import { FC, CSSProperties } from 'react';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { WbBadge } from '../../WbBadge';
import { TerminatedIcon as Terminated, TerminatedOutlineIcon } from './Icons';
import { useStyles } from './style';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const TerminatedIcon: FC<Props> = ({ style, variant }) => {
  const classes = useStyles();
  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title="The execution has been terminated"
      icon={
        variant === 'reduced' ? (
          <span>
            <Terminated className={`${classes.icon}`} style={style} />
          </span>
        ) : (
          <WbBadge
            variant="disabled"
            startIcon={<TerminatedOutlineIcon fontSize="small" />}
          >
            Terminated
          </WbBadge>
        )
      }
    />
  );
};
